var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-input",
    {
      attrs: {
        name: _vm.name,
        "data-vv-as": _vm.$t("label"),
        placeholder: _vm.$t("label")
      },
      model: {
        value: _vm.label,
        callback: function($$v) {
          _vm.label = $$v
        },
        expression: "label"
      }
    },
    [
      _c("q-autocomplete", {
        attrs: {
          "static-data": { field: "label", list: _vm.labels },
          "min-characters": 0
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }